import React from 'react'
import i18next from 'i18next';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux'
import { closeConfirmDialog } from '../store/confirmDialog/actions';

const ConfirmDialog = (props) => {
	// confirmLabel benennt die Aktion statt "Ok" - bei einer unwiderruflichen Meldung
	// soll der bestaetigende Knopf sagen, was er tut.
	const { isOpen, onClose, onConfirm = () => console.log("onConfirm"), title, message, confirmLabel } = props
	return(
		<>
		<Modal centered={true} isOpen={isOpen} toggle={ () => onClose() }>
		<ModalHeader toggle={ () => onClose()}>
			{title}
		</ModalHeader>
		<ModalBody className="backgroundColor">
			<div className="lead">{message}</div>
		</ModalBody>
		<ModalFooter  className="backgroundColor">
			{/* Bestaetigen schliesst den Dialog. Vorher musste sich jeder Aufrufer selbst darum
			    kuemmern - einer rief closeConfirmDialog von Hand, beim Melden horchte der
			    Reducer eigens auf TEILNEHMER_MELDEN_REQUESTED, und wer beides nicht tat, liess
			    den Dialog nach der Aktion offen stehen. */}
			{ onConfirm !== null && 
		  <button type="button" className="btn btn-warning" onClick = { (e) => { onConfirm(); onClose(); } }>{confirmLabel || i18next.t('ok')}</button>
			}
		  <button type="button" className="btn btn-secondary" onClick = { (e) => onClose() }>{i18next.t('cancel')}</button>
		</ModalFooter>
	</Modal>
	</>
	)
}
const mapStateToProps = (state) => {
	return {
		isOpen: state.confirmDialog.isOpen,
		title: state.confirmDialog.title,
		message: state.confirmDialog.message,
		confirmLabel: state.confirmDialog.confirmLabel,
		onConfirm: state.confirmDialog.onConfirm
	}
} 
const mapDispatchToProp = (dispatch) => ({
	onClose: () => dispatch(closeConfirmDialog()),
})
export default connect(mapStateToProps, mapDispatchToProp)(ConfirmDialog)